import { render, staticRenderFns } from "./Element.vue?vue&type=template&id=2ee4c0fa&scoped=true&"
import script from "./Element.vue?vue&type=script&lang=js&"
export * from "./Element.vue?vue&type=script&lang=js&"
import style0 from "./Element.vue?vue&type=style&index=0&id=2ee4c0fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee4c0fa",
  null
  
)

export default component.exports